import Sidebar from './Sidebar'
import Topbar from './Topbar'
import CommandPalette from '@/components/ui/CommandPalette'
import HotkeyHelp from '@/components/ui/HotkeyHelp'

interface PortalLayoutProps {
  children: React.ReactNode
}

export default function PortalLayout({ children }: PortalLayoutProps) {
  return (
    <div className="portal-layout">
      <Topbar />
      <Sidebar />
      <main className="portal-main" id="main-content">
        {children}
      </main>
      <CommandPalette />
      <HotkeyHelp />
    </div>
  )
}
